module.exports = __webpack_public_path__ + "media/images/ava-1d4ed1fc26aa9cf5cc1b9594e5b5b345.png";